import React, { useState } from "react";
import { calculatorFields, type CalculatorKey } from "../../data/calculator";
import { formatUSD } from "../../utils/currency";
import { useCountUp } from "../../hooks/useCountUp";
import { CTAButton } from "../CTAButton";
import { Reveal, STAGGER } from "../Reveal";
import { SectionHeader } from "../SectionHeader";
import { CalculatorInput } from "./CalculatorInput";
type Values = Record<CalculatorKey, number>;
const initialValues = calculatorFields.reduce((acc, f) => ({
  ...acc,
  [f.key]: f.defaultValue
}), {} as Values);
const DISCLAIMER = "Es una estimación basada en tus propios números, no una promesa de resultados.";
export function CostCalculator() {
  const [values, setValues] = useState<Values>(initialValues);
  const atRisk = values.leads * (values.pct / 100) * values.value;
  const leadsAtRisk = Math.round(values.leads * (values.pct / 100));
  const displayed = useCountUp(atRisk, 0.4);
  const breakdown = `${leadsAtRisk} ${leadsAtRisk === 1 ? "lead" : "leads"} × ${formatUSD(values.value)}`;
  return <section id="calculadora" aria-labelledby="calculadora-titulo" className="section-pad border-b border-line" data-id="element-104" data-mp="26tfv2mlixb2l">
      <div className="page-container" data-id="element-105" data-mp="21ukymhumvo00">
        <Reveal data-id="element-106" data-mp="2fs9jhpopav52">
          <SectionHeader number="03" label="Calculadora" titleId="calculadora-titulo" title="¿Cuánto te cuesta no responder a tiempo?" data-id="element-107" data-mp="2fqq8adhwjaa5" />
        </Reveal>

        <Reveal delay={STAGGER} className="mt-10 grid rounded-[3px] border border-lineStrong md:mt-12 md:overflow-hidden lg:grid-cols-12" data-id="element-108" data-mp="1n3lvvnghbtoc">
          {/* Mobile: sticky result on top of the card */}
          <div className="sticky top-16 z-10 border-b border-lineStrong bg-ink px-5 py-4 md:hidden" aria-live="polite" aria-atomic="true" data-id="element-109" data-mp="1wuzza6bjxdmr">
            <p className="eyebrow" data-id="element-110" data-mp="14arphhwx99vq">Oportunidades en riesgo al mes</p>
            <p className="mt-2 font-display text-[40px] leading-none tracking-[-0.01em] text-gold tabular-nums" data-id="element-111" data-mp="zd00avnnw1v8">
              <span className="sr-only" data-id="element-112" data-mp="2zfr4799se6ix">{formatUSD(atRisk)}</span>
              <span aria-hidden="true" data-id="element-113" data-mp="34ec8bjs5tacn">{formatUSD(displayed)}</span>
            </p>
            <p className="mt-2 text-[13px] text-muted" data-id="element-114" data-mp="395ao8i98k6fd">{breakdown}</p>
          </div>

          <div className="bg-surface lg:col-span-7" data-id="element-115" data-mp="3e4nl7vttmtvo">
            {calculatorFields.map(field => <CalculatorInput key={field.key} field={field} value={values[field.key]} onChange={v => setValues(prev => ({
            ...prev,
            [field.key]: v
          }))} data-id="element-116" data-mp="2gheunmeyqumt" />)}
          </div>

          {/* Mobile: disclaimer + CTA */}
          <div className="border-t border-lineStrong bg-ink px-5 py-6 md:hidden" data-id="element-117" data-mp="2uhfv50rbg01r">
            <p className="text-[13px] leading-relaxed text-muted" data-id="element-118" data-mp="5p3sqz0z5fho">{DISCLAIMER}</p>
            <div className="mt-6" data-id="element-119" data-mp="5rgapc6qfpuq">
              <CTAButton source="calculator" label="QUIERO RECUPERAR ESOS LEADS" data-id="element-120" data-mp="9q5ubmid63mt" />
            </div>
          </div>

          {/* Desktop result column */}
          <div className="hidden flex-col border-t border-lineStrong bg-ink px-10 py-10 md:flex lg:col-span-5 lg:border-l lg:border-t-0 lg:py-12" data-id="element-121" data-mp="1uau6zjiw4xty">
            <p className="eyebrow" data-id="element-122" data-mp="1lfmjscno0rr4">Oportunidades en riesgo al mes</p>
            <p className="mt-4 break-words font-display text-[56px] leading-none tracking-[-0.01em] text-gold tabular-nums" aria-live="polite" aria-atomic="true" data-id="element-123" data-mp="1ghcntzu49n4g">
              <span className="sr-only" data-id="element-124" data-mp="16ingh0zujl2g">{formatUSD(atRisk)}</span>
              <span aria-hidden="true" data-id="element-125" data-mp="16li22vuljbxg">{formatUSD(displayed)}</span>
            </p>
            <p className="mt-4 text-[15px] text-muted" data-id="element-126" data-mp="12htsy8qbg8a3">{breakdown}</p>
            <p className="mt-8 border-t border-line pt-5 text-[14px] leading-relaxed text-muted" data-id="element-127" data-mp="xjijhz3xnzse">
              {DISCLAIMER}
            </p>
            <div className="mt-auto pt-10" data-id="element-128" data-mp="2wti9gfc74iwl">
              <CTAButton source="calculator" label="QUIERO RECUPERAR ESOS LEADS" data-id="element-129" data-mp="2rw8g4olorn3h" />
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}